// extracted by mini-css-extract-plugin
export default {"BoxContainer":"_BoxContainer--uvWDX","BoxMenu":"_BoxMenu--Hbiib","Visible":"_Visible--H77Yr","ImportSparkle":"_ImportSparkle--E9qNK"};